<template>
    <div class="message--pill">
        <!-- <span
            class="message"
            :class="{
                'message--success': alarmData.error_type == '',
                'message--info': alarmData.error_type == 'IN',
                'message--danger': alarmData.error_type == 'AL',
                'message--warning': alarmData.error_type == 'FE',
                'message--inactive': alarmData.error_code == 599,
            }"
            v-tooltip.left="showTooltip"
        >
            <span v-if="alarmData.error_code == 599">{{ $t('common.inactive_message') }}</span>
            <span v-else-if="alarmData.error_code">{{ alarmData.error_type }} {{ alarmData.error_code }}</span>
            <span v-else>&nbsp;</span>
        </span> -->
        <pill-label v-if="alarmData.error_code >= 1 && alarmData.error_code <= 199" :left="alarmData.error_type" :right="alarmData.error_code" :color="'#ef2929'" v-tooltip.left="showTooltip" />
        <pill-label v-else-if="alarmData.error_code >= 200 && alarmData.error_code <= 399" :left="alarmData.error_type" :right="alarmData.error_code" :color="'#fcaf3e'" v-tooltip.left="showTooltip" />
        <pill-label v-else-if="alarmData.error_code >= 400 && alarmData.error_code <= 598" :left="alarmData.error_type" :right="alarmData.error_code" :color="'#729fcf'" v-tooltip.left="showTooltip" />
        <pill-label v-else-if="alarmData.error_code == 599" :left="$t('common.inactive_message')" :color="'#9d9d9d'" v-tooltip.left="showTooltip" />
        <pill-label v-else-if="alarmData.error_code > 599 && alarmData.error_code < 700" :left="'PRE'" :right="alarmData.error_code" :color="'#729fcf'" v-tooltip.left="showTooltip" />
        <pill-label v-else-if="alarmData.error_code" :right="alarmData.error_code" :color="'#729fcf'" v-tooltip.left="showTooltip" />
        <pill-label v-else :left="'OK'" :color="'#40b003'" v-tooltip.left="showTooltip" />
    </div>
</template>

<script>
import { VTooltip } from 'v-tooltip';
import PillLabel from '@/components/PillLabel';

export default {
    name: 'alarm-message',
    components: {
        PillLabel,
    },
    props: {
        alarm: {
            type: Object,
            default() {
                return { error_type: '', error_code: '', error_message: 'OK' };
            },
        },
        tooltip: {
            type: Boolean,
            default: false,
        },
        logs: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        alarmData() {
            return {
                error_type: this.getErrorType(this.alarm.error_code, this.alarm.resolved_at),
                error_code: this.getErrorType(this.alarm.error_code, this.alarm.resolved_at) === '' ? '' : this.alarm.error_code,
                error_message: this.alarm.error_message,
            };
        },
        showTooltip() {
            let retval = false;
            if (this.tooltip && this.getErrorType(this.alarm.error_code, this.alarm.resolved_at) === '') {
                // retval = { content: 'OK', offset: 10 };
            } else if (this.tooltip) {
                retval = { content: this.alarmData.error_message, offset: 10 };
            }
            return retval;
        },
    },
    directives: {
        tooltip: VTooltip,
    },
    methods: {
        getErrorType(errorCode, resolvedAt) {
            if (errorCode === null || errorCode === '' || (resolvedAt !== null && new Date(resolvedAt) < new Date() && this.logs === false)) {
                return '';
            }

            if (errorCode < 200) {
                return 'AL';
            } else if (errorCode >= 200 && errorCode < 400) {
                return 'FE';
            } else if (errorCode >= 400 && errorCode < 600) {
                return 'IN';
            }
        },
    },
};
</script>

<style scoped lang="scss">
.message {
    &--pill {
        text-align: center;
        display: inline-block;
    }

    display: inline-block;
    min-width: 60px;
    height: 30px;
    margin: 2px 9px;
    position: relative;
    z-index: 1;
    border-width: 1px 0;
    border-style: solid;

    line-height: 28px;
    color: white;
    font-size: 12px;
    text-align: center;

    &:before,
    &:after {
        content: '';
        border-style: solid;
        position: absolute;
        top: 5px;
        z-index: -1;
        width: 18px;
        height: 18px;
        border-width: 0 0 1px 1px;
    }

    &:before {
        left: -9px;
        transform: rotate(45deg) skew(15deg, 15deg);
    }

    &:after {
        right: -9px;
        transform: rotate(-135deg) skew(15deg, 15deg);
    }

    $variations: (
        success $color-success $color-success-dark,
        warning $color-warning $color-warning-dark,
        danger $color-danger $color-danger-dark,
        info $color-info $color-info-dark,
        inactive $color-gray-another darken($color-gray-another, 10%)
    );

    @each $variation in $variations {
        $key: nth($variation, 1);
        $background-color: nth($variation, 2);
        $shadow-color: nth($variation, 3);

        &--#{$key} {
            box-shadow: 0 0 0 2px $shadow-color, inset 0 0 0 1px $shadow-color;

            &,
            &:before,
            &:after {
                background-color: $background-color;
                border-color: $background-color;
            }

            &:before,
            &:after {
                box-shadow: -2px 2px 0 0 $shadow-color, inset 1px -1px 0 0 $shadow-color;
            }
        }
    }
}
</style>
